import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltReactionPinCountWireframe from './VeltReactionPinCountWireframe/VeltReactionPinCountWireframe';
import VeltReactionPinEmojiWireframe from './VeltReactionPinEmojiWireframe/VeltReactionPinEmojiWireframe';
var VeltReactionPinWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-wireframe", __assign({}, transformedProps), children));
};
VeltReactionPinWireframe.Count = VeltReactionPinCountWireframe;
VeltReactionPinWireframe.Emoji = VeltReactionPinEmojiWireframe;
export default VeltReactionPinWireframe;
